import React from 'react';
import PropTypes from 'prop-types';
import './App.scss';

import listenToTheStory from './assets/images/Sound_listentext.jpg';
import playButton from './assets/images/playbtn.jpg';
import pauseButton from './assets/images/pausebtn.jpg';

const Story = props => {
  const { onPlayClick, imageSrc, index, isPlaying, title, subTitle ,desc, descEN } = props;

  const handlePlayClick = () => {
    onPlayClick(index);
  };

  return (
<div className="story" id={"story-"+(index+1)}>
      <div className="vertical-border" />
      <img className="story-image" src={imageSrc} alt={title} />
      <h3>
        <span dangerouslySetInnerHTML={{__html: title}}></span>
        {!!subTitle && <span className="subtitle">{subTitle}</span>}
      </h3>
	  <div class="desc" dangerouslySetInnerHTML={{__html: desc}}></div>
      <div className="listen-story-wrapper" onClick={handlePlayClick}>
        <h4>LISTEN TO THE STORY</h4>
        <img
          className="listen-image"
          src={listenToTheStory}
          alt="Listen to the story"
        />
        <button type="button" className="play-story-button">
          {!isPlaying && <img src={playButton} alt="Play" />}
          {isPlaying && <img src={pauseButton} alt="Pause" />}
        </button>
      </div>
    </div>
  );
};

Story.propsType = {
  onPlayClick: PropTypes.func.isRequired,
  imageSrc: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  desc: PropTypes.string,
  descEN: PropTypes.string,
};

Story.defaultProps = {
  subTitle: ''
};

export default Story;
